module.exports = __webpack_public_path__ + "media/fire-burning.b3b70864.mp4";